import { render, staticRenderFns } from "./ProgramColumns.vue?vue&type=template&id=24a0e1ca&scoped=true&"
import script from "./ProgramColumns.vue?vue&type=script&lang=ts&"
export * from "./ProgramColumns.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramColumns.vue?vue&type=style&index=0&id=24a0e1ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a0e1ca",
  null
  
)

export default component.exports